import { render, staticRenderFns } from "./RichTextDisplay.vue?vue&type=template&id=d29ddeaa&scoped=true"
import script from "./RichTextDisplay.vue?vue&type=script&lang=ts"
export * from "./RichTextDisplay.vue?vue&type=script&lang=ts"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&id=d29ddeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29ddeaa",
  null
  
)

export default component.exports